import React from "react";
import Footer from "./landingFooter";
import Navbar from "./landingNav";

import "./index.scss";

const LandingLayout = ({ children }) => {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
    </>
  );
};

export default LandingLayout;
